import { createSelector } from "reselect"

export const selectWidgetMeta =
    createSelector(
        (state, props) => props.widget,
        widget => (
            widget &&
            widget.meta
        )
    )

export const selectWidgetHeaderTitle =
    createSelector(
        (state, props) => props.widget,
        widget => (
            widget &&
            widget.meta.text
        )
    )

export const selectWidgetKey =
    createSelector(
        (state, props) => props.widget,
        widget => (
            widget &&
            widget.meta.id
        )
    )

export const selectWidgetDataSources =
    createSelector(
        (state, props) => props.widget,
        widget => (
            widget &&
            widget.data_sources
        ) || []
    )

export const selectWidgetDescription =
    createSelector(
        (state, props) => props.widget,
        widget => (
            widget &&
            widget.meta.description
        )
    )

export const selectWidgetSafedSearch =
    createSelector(
        selectWidgetDataSources,
        dataSources => dataSources.length && dataSources[0].safed_search
    )

export const selectWidgetQuorumDataType =
    createSelector(
        selectWidgetSafedSearch,
        safedSearch => (
            safedSearch
                ? (
                    DjangIO.app.models.QuorumDataType.by_value(
                        safedSearch.data_type
                    )
                )
                : undefined
        )
    )

export const selectWidgetAddedIds =
    createSelector(
        selectWidgetSafedSearch,
        safedSearch => (safedSearch && safedSearch.added_ids) || []
    )

export const selectWidgetFilters =
    createSelector(
        selectWidgetSafedSearch,
        safedSearch => (safedSearch && safedSearch.filters) || []
    )

export const dataSourceHasData = (dataSource) => {
    if (!dataSource) {
        return false
    }

    const safedSearch = dataSource.safed_search
    if (safedSearch) {
        const { filters } = safedSearch
        const addedIds = safedSearch.added_ids

        return Boolean(
            (filters && filters.length)
            || (addedIds && addedIds.length)
        )
    }

    return false
}

export const selectCanWidgetLoad = createSelector(
    selectWidgetFilters,
    selectWidgetAddedIds,
    (filters, addedIds) => Boolean(filters.length || addedIds.length)
)
